import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { theme } from "../../styles";
import { PlusOutlined } from "@ant-design/icons";
import {
  getyarnQualities,
  deleteYarnQuality,
} from "../../helper/utils/api/settings";
import EditYarnQualityModal from "../../components/Modals/Setting/EditYarnQualityModal";

import { Grid, Tabel, DropDown, Button, Typography, Loading } from "../../core";
import AddYarnQualityModal from "../../components/Modals/Setting/AddYarnQualityModal";
import DeleteModals from "../../components/Modals/deleteModals";
const { colors } = theme;
const btnProps = {
  width: "130px",
  height: "30px",
  bg: colors.pink,
  margin: "10px 0px 10px auto",
};
const typoProps = {
  align: "center",
  as: "h6",
  weight: "600",
  color: "white",
};
const YarnQuality = () => {
  const [modalState, setModalState] = useState({
    addyarnQaulityModal: false,
    editYarnQualityModal: false,
    deleteConfirmModal: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [record, setRecord] = useState({
    recordToDelete: {},
    recordToEdit: {},
  });
  const [yarnQualities, setYarnQualities] = useState([]);

  useEffect(() => {
    getYarnQualities();
  }, []);

  const yarnQualityDeleteHandler = (record) => {
    setModalState((prev) => ({
      ...prev,
      deleteConfirmModal: true,
    }));
    setRecord({
      recordToDelete: record,
      recordToEdit: {},
    });
  };

  const yarnQualityEditHandler = (record) => {
    console.log("record", record);

    setModalState((prev) => ({
      ...prev,
      editYarnQualityModal: true,
    }));
    setRecord({
      recordToDelete: {},
      recordToEdit: record,
    });
  };

  const menu = (index, record) => {
    return (
      <Menu>
        <Menu.Item onClick={() => yarnQualityDeleteHandler(record)}>
          Delete
        </Menu.Item>
        <Menu.Item onClick={() => yarnQualityEditHandler(record)}>
          Edit
        </Menu.Item>
      </Menu>
    );
  };

  const getYarnQualities = async () => {
    let companyId = localStorage.getItem("companyId");
    if (companyId) {
      setIsLoading(true);
      try {
        let {
          data: { result },
        } = await getyarnQualities({ companyId });

        setYarnQualities(result);
      } catch (error) {
        console.log("error from get yarn quality", error);
      }
      setIsLoading(false);
    }
  };

  const openModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: true,
    }));
  };

  const closeModal = (name) => {
    setModalState((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const confirmDeleteHandler = async () => {
    if (record.recordToDelete) {
      let { _id } = record.recordToDelete;
      if (_id) {
        setIsLoading(true);
        try {
          await deleteYarnQuality(_id);
          closeModal("deleteConfirmModal");
          await getYarnQualities();
        } catch (error) {}
        setIsLoading(false);
      }
    }
  };

  const columns = [
    {
      title: "SR #",
      dataIndex: "SNo",
      key: "S.No",
      render: (text, record, index) => {
        return <span>{index + 1}</span>;
      },
      width: 150,
    },
    {
      title: "count",
      dataIndex: "count",
      key: "count",
      width: 150,
    },
    {
      title: "type ",
      dataIndex: "type",
      key: "type",
      width: 150,
    },
    {
      title: "brand",
      dataIndex: "brand",
      key: "brand",
      width: 150,
    },
    {
      title: "consize",
      dataIndex: "consize",
      key: "consize",
      width: 150,
    },

    {
      title: "",
      dataIndex: "action",
      width: 150,
      render: (text, record, index) => (
        <DropDown overlay={() => menu(index, record)} />
      ),
    },
  ];

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <div>
        <Button {...btnProps} onClick={() => openModal("addyarnQaulityModal")}>
          <Typography {...typoProps} noMargin>
            <PlusOutlined />
            Add Yarn Quality
          </Typography>
        </Button>
      </div>

      <Tabel columns={columns} data={yarnQualities} />
      {modalState.addyarnQaulityModal && (
        <AddYarnQualityModal
          addyarnQaulityModal={modalState.addyarnQaulityModal}
          getYarnQualities={getYarnQualities}
          closeModal={closeModal}
        />
      )}

      {modalState.deleteConfirmModal && (
        <DeleteModals
          deleteModalsOpen={modalState.deleteConfirmModal}
          closeModal={closeModal}
          confirmDeleteHandler={confirmDeleteHandler}
        />
      )}

      {modalState.editYarnQualityModal && (
        <EditYarnQualityModal
          editYarnQualityModal={modalState.editYarnQualityModal}
          closeModal={closeModal}
          getYarnQualities={getYarnQualities}
          dataToEdit={record.recordToEdit}
        />
      )}
    </Grid>
  );
};

export default YarnQuality;
